import { DeviceSpaces } from "libs/core/src/lib/repository/parking-lot/models/device-spaces.model";

export abstract class DeviceSpaceServiceBase {
    abstract storeCameraSpaces(parkingLotId: number): void;
    abstract checkDeviceSpace(deviceSpaceId: number): boolean;
    abstract getDeviceSpaceById(deviceSpaceId: number): DeviceSpaces;
}